import {
  type Action, type AsyncStateObject, type ErrorResponse
} from '../../../interfaces'
import { APP_ACTION_STATUS, ASSESSMENT_ACTIONS, COMMON_ACTIONS } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<ErrorResponse> = {
  data: { message: '' },
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined

}

const assessmentSubmitReducer = (state = INITIAL_STATE, action: Action<ErrorResponse>) => {
  switch (action.type) {
    case ASSESSMENT_ACTIONS.SUBMIT_ASSESSMENT + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case ASSESSMENT_ACTIONS.SUBMIT_ASSESSMENT + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case ASSESSMENT_ACTIONS.SUBMIT_ASSESSMENT + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case ASSESSMENT_ACTIONS.SUBMIT_ASSESSMENT + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default assessmentSubmitReducer
